/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IndexStatusResponse
 */
export interface IndexStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof IndexStatusResponse
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexStatusResponse
     */
    indexAlias: string;
    /**
     * 
     * @type {string}
     * @memberof IndexStatusResponse
     */
    oldVariant: string;
    /**
     * 
     * @type {string}
     * @memberof IndexStatusResponse
     */
    targetVariant: string;
    /**
     * 
     * @type {number}
     * @memberof IndexStatusResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof IndexStatusResponse
     */
    progression: number;
}

/**
 * Check if a given object implements the IndexStatusResponse interface.
 */
export function instanceOfIndexStatusResponse(value: object): value is IndexStatusResponse {
    if (!('indexAlias' in value) || value['indexAlias'] === undefined) return false;
    if (!('oldVariant' in value) || value['oldVariant'] === undefined) return false;
    if (!('targetVariant' in value) || value['targetVariant'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('progression' in value) || value['progression'] === undefined) return false;
    return true;
}

export function IndexStatusResponseFromJSON(json: any): IndexStatusResponse {
    return IndexStatusResponseFromJSONTyped(json, false);
}

export function IndexStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndexStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'language': json['language'] == null ? undefined : json['language'],
        'indexAlias': json['indexAlias'],
        'oldVariant': json['oldVariant'],
        'targetVariant': json['targetVariant'],
        'total': json['total'],
        'progression': json['progression'],
    };
}

export function IndexStatusResponseToJSON(value?: IndexStatusResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'language': value['language'],
        'indexAlias': value['indexAlias'],
        'oldVariant': value['oldVariant'],
        'targetVariant': value['targetVariant'],
        'total': value['total'],
        'progression': value['progression'],
    };
}

